import Buttons from "../../../../../../base/basicComponents/button";
import {
  SectionStatusDiv,
  ApplyJBTagForFiles,
} from "../../../../../../base/basicComponents/status";
import UploadFile from "../../../../../../base/basicComponents/uploadFile";
import ApproveProcedureFileTbody from "../../../../procedureFileSections/fields/procedureFileTbodyFields/approveProcedureFileTbody";
import { PreviewFileLink } from "app/pages/previewFile";
import EllipsisToolTip from "base/basicComponents/ellipsisToolTip";

export default class ApplyJbFileTbody extends ApproveProcedureFileTbody {
  returnButton = (row: any, column: any, rowIndex: any, status: any) => {
    if (column.hideActionButton !== undefined && column.hideActionButton(row)) {
      return;
    }
    return (
      <div className="buttonTd-content">
        {
          <>
            <Buttons
              color={column.approveColor}
              size="small"
              onClick={(e: any) => column.onApproveClick(e.target.attributes.rowindex.value)}
              disabled={row.isApproveDisabled}
              rowindex={rowIndex}
              testid={`apply-jb-file-approve-btn-${rowIndex}`}
            >
              {column.approveText}
            </Buttons>
            <UploadFile
              fileInputRef={row.replaceRef}
              isMultiple={false}
              handleFileSelect={this.props.handleFileSelect}
              rowindex={rowIndex}
              isSupportingFile={false}
            />
          </>
        }
        {
          <Buttons
            color={column.returnColor}
            size="small"
            onClick={() => column.onReturnClick(rowIndex)}
            disabled={row.isReturnDisabled}
            rowindex={rowIndex}
            testid={`apply-jb-file-return-btn-${rowIndex}`}
          >
            {column.returnText}
          </Buttons>
        }
      </div>
    );
  };

  returnTag = (column: any, rowColumn: any) => {
    return (
      column.dataName === "status" && (
        <>
          <SectionStatusDiv status={rowColumn.value} />
        </>
      )
    );
  };

  returnFileName = (rowColumn: any, column: any, row: any) => {
    return (
      <div className="fileNameContainer">
        <EllipsisToolTip
          children={
            <PreviewFileLink
              fileId={row.data.find((i: any) => i.name === "fileId").value}
              fileName={rowColumn.value}
            >
              {rowColumn.value}
            </PreviewFileLink>
          }
          title={rowColumn.value}
          placement="top"
        />
        {rowColumn.tagValue !== null && <ApplyJBTagForFiles type={rowColumn.tagValue} />}
      </div>
    );
  };
}
